import { ReactNode, useEffect, useMemo } from 'react'
import { initialQueryState, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import {
  ActiveFilter,
  ActiveFiltersBar,
  Input,
  TableFilter,
  TableFilters,
} from '../../../../../../components'

type Props = {
  /** Conteúdo à direita da linha dos campos (ex.: "Adicionar" ou barra de seleção em lote). */
  actions?: ReactNode
}

export const ExameClienteListSearchComponent = ({ actions }: Props) => {
  const { updateState } = useQueryRequest()
  const { response, isLoading } = useQueryResponse()
  const { filters, setFilter, clearFilters } = useListFilters()
  const total = response?.totalElements ?? 0

  const debouncedFilters = useDebounce(filters, 500)

  const search = useMemo(() => {
    const exame = debouncedFilters.exame.trim()
    return exame ? `exame~*${exame}*` : ''
  }, [debouncedFilters])

  useEffect(() => {
    updateState({ ...initialQueryState, search })
  }, [search, updateState])

  // Chip da faixa "Filtros ativos": o × limpa o campo.
  const activeFilters: ActiveFilter[] = filters.exame.trim()
    ? [
        {
          key: 'exame',
          label: 'Exame',
          value: `“${filters.exame.trim()}”`,
          onRemove: () => setFilter('exame', ''),
        },
      ]
    : []

  const resultado = isLoading
    ? 'Buscando…'
    : `${total} ${total === 1 ? 'exame encontrado' : 'exames encontrados'}`

  return (
    <TableFilters
      actions={actions}
      footer={
        <ActiveFiltersBar filters={activeFilters} onClearAll={clearFilters} summary={resultado} />
      }
    >
      <TableFilter label='Exame' wide>
        <Input
          placeholder='Digite o exame'
          value={filters.exame}
          onChange={(e) => setFilter('exame', e.target.value)}
        />
      </TableFilter>
    </TableFilters>
  )
}
